var _path, _polygon, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSumIsuredLinearIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.54,38h.46V203.85h43.25V123.06h-31.15v-14.06h31.65c7.49,0,13.55,6.07,13.56,13.56v81.29h43.21V123.06h-31.16v-14.06h31.64c7.48,.01,13.54,6.58,13.55,14.06v80.79h43.23V123.06h-32.15v-14.06h32.65c7.48,.01,13.55,6.58,13.56,14.06v80.79c-.02,7.48-4.37,14-14.06,14H49c-9.89,0-13.98-6.53-14-14V51.56c0-7.48,6.06-13.54,13.54-13.56Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "184.97 62.73 61.25 61.8 61.15 72.39 184.87 73.32 184.97 62.73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.38,54.88l6.32-8.75,25.35,18.32c2.41,1.74,2.96,5.1,1.23,7.51-.36,.5-.8,.94-1.31,1.29l-25.69,17.84-6.15-8.87,19.43-13.48-19.17-13.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSumIsuredLinearIcon);
export default __webpack_public_path__ + "static/media/SumIsuredLinearIcon.42e7df31c6017d4b7023c2ce71de7155.svg";
export { ForwardRef as ReactComponent };